import { useQuery } from "@tanstack/react-query";
import createPrivateAdminPanelInstance from "../../../api/PrivateAdminPanelInstance";
import { API_ROUTES } from "../../../api/ApiRoutes";

const fetchCasinoConfigurationProviders = async (search = "") => {
  const token = JSON.parse(localStorage.getItem("token"));
  const privateInstance = createPrivateAdminPanelInstance(token?.AccessToken);

  const params = { page: 1, page_size: 50 };
  if (search) params.search = search;

  const response = await privateInstance.get(API_ROUTES.GET_ADMIN_PROVIDERS, {
    params,
  });

  const body = response?.data;
  const items =
    body?.data?.items ||
    body?.data?.providers ||
    body?.data ||
    body?.providers ||
    body?.items ||
    [];

  return Array.isArray(items) ? items : [];
};

export const useCasinoConfigurationProviders = (options = {}) => {
  const { enabled = true, search = "" } = options;
  return useQuery({
    queryKey: ["casinoConfiguration", "providers", "global", search],
    queryFn: () => fetchCasinoConfigurationProviders(search),
    staleTime: 0,
    refetchOnMount: "always",
    enabled,
  });
};

export { fetchCasinoConfigurationProviders };
